import { mergeProps } from '@react-aria/utils';
import type { Variants } from 'framer-motion';
import { motion } from 'framer-motion';
import React from 'react';

import { useMeasure } from '@zoomit/primitives';
import { useSafeMotion } from '@zoomit/web-kit';

type Props = {
  children: React.ReactNode;
  isActive?: boolean;
  initialAnimation?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

export const HeightMotion = (props: Props) => {
  const { children, isActive = true, initialAnimation = false, ...rest } = props;
  const { ref: searchWrapperRef, rect } = useMeasure<HTMLDivElement>();

  const searchInstanceVariants: Variants = {
    open: {
      height: 'auto',
    },
    close: {
      height: initialAnimation ? 0 : 'auto',
    },
  };

  const safeMotion = useSafeMotion({
    variants: searchInstanceVariants,
    animate: { height: isActive ? rect.height : 0 },
    exit: 'close',
    initial: 'close',
  });

  return (
    <motion.div
      transition={{
        type: 'spring',
        damping: 100,
        stiffness: 1000,
      }}
      {...mergeProps(safeMotion)}
    >
      <div ref={searchWrapperRef} {...rest}>
        {children}
      </div>
    </motion.div>
  );
};
